import core from './core';

const VideoEmbed = core.extend({
	constructor(settings) {
		_.bindAll(this, 'waitForAPI');

		this.config = {
			el: document.querySelector('.js-video-teaser'),
			videoWrapper: '.js-video-wrapper',
			openedClass: 'is-open',
			closeButton: '.js-close-btn',
			iFrameClass: '.js-youtube-embed',
			apiRetry: {
				delay: 25,
				attempts: 10,
			},
		};

		this.apiCallAttempt = 0;
		this.apiRetryDelay = this.config.apiRetry.delay;
		this.apiRetryTimer = null;

		_.extend(this.config, settings);

		this.waitForAPI();
	},

	waitForAPI() {
		clearTimeout(this.apiRetryTimer);

		if (this.apiCallAttempt === this.config.apiRetry.attempts) {
			return;
		}

		if (typeof window.YT !== 'undefined' && typeof YT.Player !== 'undefined') {
			this.init();
			this.attachEvents();
		} else {
			this.apiCallAttempt += 1;
			this.apiRetryTimer = setTimeout(this.waitForAPI, this.apiRetryDelay);
			this.apiRetryDelay *= 2;
		}
	},

	init() {
		const element = jQuery(this.config.el);
		const youTubeInner = element.find(this.config.iFrameClass)[0];
		const youTubeId = element.find(this.config.iFrameClass).data('id');

		this.player = new YT.Player(youTubeInner, {
			videoId: youTubeId,
			host: 'https://www.youtube-nocookie.com',
			playerVars: { rel: 0 },
		});
	},

	attachEvents() {
		jQuery(this.config.el)
			.find(this.config.videoWrapper)
			.on('click', (e) => {
				e.preventDefault();

				jQuery(e.currentTarget).addClass(this.config.openedClass);

				this.player.playVideo();
			});

		jQuery(this.config.el)
			.find(this.config.closeButton)
			.on('click', (e) => {
				e.stopPropagation();

				this.player.stopVideo();

				jQuery(this.config.el).find(this.config.videoWrapper).removeClass(this.config.openedClass);
			});

		jQuery(window).on('resize', () => {
			// if player is playing and the block with a player is hidden stop the player
			if (
				this.player.getPlayerState &&
				this.player.getPlayerState() === 1 &&
				jQuery(this.config.iFrameClass).is(':hidden')
			) {
				this.player.stopVideo();
			}
		});
	},
});

export default VideoEmbed;
